import React from 'react';
import { FormikHelpers } from 'formik';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

import {
  FormikWrapper,
  FormTextarea as Textarea,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  UI_OPERATION_STATUS_REQUEST,
  UI_OPERATION_STATUS_SUCCESS,
  UI_OPERATION_STATUS_ERROR,
} from '@uncinc/react-drupal-core';

import { Button } from '../../../components';
import useOperationStatus from '../../../hooks/useOperationStatus';
import useTypedDispatch from '../../../hooks/useTypedDispatch';
import { buddyInviteRefuse } from '../../../store/actions/Buddy';

interface BuddyInviteRefuseValues {
  refusalReason: string;
}

const BuddyInviteRefuseForm = () => {
  const dispatch = useTypedDispatch();
  const status = useOperationStatus('buddy', 'refuse');
  const { t } = useTranslation();
  const { pairingCode } = useParams<{ pairingCode: string }>();

  const translationBase = 'pages.buddy_invite_refuse.form';

  function handleSubmit({ refusalReason }: BuddyInviteRefuseValues) {
    dispatch(buddyInviteRefuse(pairingCode, refusalReason));
  }

  if (status === UI_OPERATION_STATUS_SUCCESS) {
    return <p>{t(`${translationBase}.success_message`)}</p>;
  }

  return (
    <>
      <FormikWrapper
        initialValues={{ refusalReason: '' }}
        // eslint-disable-next-line max-len
        onSubmit={(values: BuddyInviteRefuseValues, { setSubmitting }: FormikHelpers<BuddyInviteRefuseValues>) => {
          handleSubmit(values);
          setSubmitting(false);
        }}
        validateOnBlur={false}
        validateOnChange={false}
      >
        <Textarea
          fieldName="refusalReason"
          title={t(`${translationBase}.fields.refuse_reason.label`)}
          placeholder={t(`${translationBase}.fields.refuse_reason.placeholder`)}
        />
        <Button htmlType="submit" buttonState={status === UI_OPERATION_STATUS_REQUEST && 'disabled'}>
          {t(`${translationBase}.submit`)}
        </Button>
      </FormikWrapper>

      {status === UI_OPERATION_STATUS_ERROR && (
        <p className="PageBuddyInviteRefuse__error-message">
          {t(`${translationBase}.error_message`)}
        </p>
      )}
    </>
  );
};

export default BuddyInviteRefuseForm;
